import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';

const styles = {};

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  },
  note: {
    marginTop: 10,
    color: '#FF545C'
  }
});

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    okAction,
    message,
    btnText,
    isSmall,
    note
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    const classes = useStyles();
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
            {note && <div className={classes.note}>{note}</div>}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <Button color="primary" onClick={okAction}>
            {btnText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
